// extracted by mini-css-extract-plugin
export var closeButton = "_ji-1";
export var closeX = "_ji-3";
export var container = "_ji-0";
export var image = "_ji-2";